import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import marked from "marked";
import URI from "URI/URI";
import template from "ulysses/controls/scroller.html";

"use strict";
var _id_min = 0;
function _generate_id() {
    return "asd_"+(++_id_min);
}
function Scroller(view_model, elt){
    this.view_model = view_model;
    this.$elt = $(elt).parents(".scroller-wrapper");
    this.elt = this.$elt[0];
    var _id = this.$elt.attr("id");
    if (!_id){
        _id = _generate_id();
        this.$elt.attr({"id":_id});
    }
    this.id = _id;
}
Scroller.prototype.init = function(){
    var scroller = this.$elt.data("scroller");
    if(!scroller){     
        scroller = new IScroll(this.elt, {
            mouseWheel:true,
            useTransition: true,
            scrollbars:true,
            interactiveScrollbars:true,
            click:!uly.utils.is_mobile(),
            tap:uly.utils.is_mobile()
        });
        this.$elt.data("scroller", scroller);
        var $this = this;
        
        $this.view_model.$data.callback.subscribe(function(data) {
            scroller.refresh();
        });
        scroller.on("scrollEnd", function () {
            if(!(scroller.maxScrollY - scroller.y)){
                ko.unwrap($this.view_model.$data.callback)(scroller.refresh);
            }
        });
    }
};
Scroller.prototype.run = null;
Scroller.prototype.toogle = function(){
    clearTimeout(this.run);
    var $this = this;
    this.run = setTimeout(function(){$this.init.apply($this)}, 500);
};
ko.components.register('scroller', {
    viewModel: function(data) {
        for(var key in data)
            this[key] = data[key];
        var $this = this;
        this.afterRender = function(elt){
            if(!this.scroller)
                this.scroller = new Scroller($this, elt);
            this.scroller.toogle();
        };
        this.afterAdd = function(elt){
            $(elt).removeClass("loader");
        };
    },
    template:{require :"ulysses/controls/scroller.html"}
});
